export default __webpack_public_path__ + "static/media/app_spotify.6e904bd6.svg";